import classNames from "classnames/bind";
import styles from './TableNotification.module.css';
import PropTypes from 'prop-types';
import { formatDateToTime } from "../../../utils";

const cx = classNames.bind(styles)


function TableNotification({ dataNotification, getCode, fillNew }) {

    const handleClickToItemNotification = (code) => {
        getCode(code)
    }
    return (
        <table className={cx('table-notification')}>
            <thead style={{ width: '100%' }}>
                <tr>
                    <th>STT</th>
                    <th>Thời gian</th>
                    <th>Thông báo</th>
                    <th>Loại thông báo</th>
                    <th>Người nhận</th>
                    <th></th>
                </tr>
            </thead>
            <tbody className={cx('body-table')}>
                {dataNotification?.length > 0 && dataNotification.length === 0 ?
                    <></> :
                    <>
                        {dataNotification.map((item, index) => {
                            // if (item.SEEN === 0) {
                            return (
                                <tr key={index} onClick={() => handleClickToItemNotification(item.time)}
                                    style={!item.seen ? { backgroundColor: 'rgba(0, 64, 255, 0.1)' } : {}}
                                    className={cx('new_notification')}
                                >
                                    <td>{index + 1}</td>
                                    <td>{formatDateToTime(item.time)}</td>
                                    <td>{item.detail}</td>
                                    <td>
                                        <span className={cx('tag', item.notification_type_code === 'CODE_1' && 'normal')}>{item.name}</span>
                                    </td>
                                    <td>{item.receiver}</td>
                                    <td>
                                        {!item.seen && <span className={cx('tick-new')}></span>}
                                    </td>
                                </tr>
                            )
                        })}

                    </>
                }
            </tbody>
        </table >
    )
}

TableNotification.propTypes = {
    dataNotification: PropTypes.array.isRequired,
    getCode: PropTypes.func,
}
export default TableNotification;